import React from "react";

function NavigationEnd({ children }) {
  return <div className={"navbar-end"}>{children}</div>;
}

export default NavigationEnd;
